<template>
    <div>
        <div class="banner-tabs">
            <div class="banner banner-mobile" v-if="isMobile"></div>
            <div class="banner" v-else>
                <!-- <div v-show="endLaoding" class="before-banner-loading"></div> -->
                <video id="introVideo" class="banner-video" muted
                src="https://anweb.annto.com/resource/video/annto-intro-banner.mp4" loop></video>
                <div class="banner-video-mask"></div>
            </div>
            <Tabs :innerMenu="innerMenu"></Tabs>
        </div>
        <keep-alive>
            <router-view></router-view>
        </keep-alive>
    </div>
</template>
<script>
import Tabs from '../components/common/tabs';
export default {
    name: 'about-index',
    data() {
        return {
            isMobile: this.COMMON.isMobile,
            outerTab: 'intro',
            endLaoding: true,
            innerMenu: [
                {
                    isCur: true,
                    name: 'intro',
                    title: '安得简介'
                },
                {
                    isCur: false,
                    name: 'culture',
                    title: '安得文化'
                },
                {
                    isCur: false,
                    name: 'news',
                    title: '新闻资讯'
                },
                {
                    isCur: false,
                    name: 'tendering',
                    title: '招标公告'
                },
                {
                    isCur: false,
                    name: 'hr',
                    title: '加入我们'
                }
            ]
        };
    },
    methods: {
        changeTab(tabname) {
            this.innerMenu.map(item => {
                if (item.name === tabname) {
                    item.isCur = true;
                } else {
                    item.isCur = false;
                }
            });

            if (tabname === this.outerTab) {
                this.innerMenu[0].isCur = true;
            }
        }
    },
    mounted() {
        const tabname = this.$route.name || this.innerMenu[0].name;
        this.changeTab(tabname);
        setTimeout(() => {
            const video = document.getElementById('introVideo');
            video && video.play();
            this.endLaoding = false;
        }, 2000);
    },
    watch: {
        $route: function() {
            const tabname = this.$route.name || this.innerMenu[0].name;
            this.changeTab(tabname);
        }
    },
    components: {
        Tabs
    }
};
</script>
<style lang="less">
@import url(../style/logistics.less);
.banner-tabs {
    .banner {
        height: 4.2rem;
        width: 100%;
        background-size: 100% 100%;
        text-align: center;
        position: relative;
    }

    .banner-mobile {
        background-image: url(../images/picture/banner/about-mobile-new.jpg);
    }

    .banner-video {
        position: absolute;
        z-index: -1;
        left: 50%;
        margin-left: -9.6rem;
        height: 100%;
    }
    .banner-link-a {
        color: #7dbdff;
        font-size: 0.16rem;
        cursor: pointer;
        margin-top: 2.1rem;
        display: inline-block;
    }
    .banner-video-mask {
        width:100%;
        height:100%;
        position:absolute;
        left:0;
        top:0;
        z-index:0;
        background-color:#000;
        opacity:0.3;
    }
    .before-banner-loading {
        height: 4.2rem;
        width: 100%;
        background-size: 100% 100%;
        text-align: center;
        position: absolute;
        background-image: url(../images/picture/banner/banner-about.jpg);
    }
}
@media screen and (max-width: 480px) {
    .banner-tabs {
        .banner {
            height: 1.75rem;
        }
    }
}
</style>
